export default {
  buyingTrades: [],
  sellingTrades: []
}
